<template>
  <div id="alarmLine"></div>
</template>
<script>
import echarts from "echarts";
export default {
  props: ["countTrendData"],
  data() {
    return {
      tuli: ["抽烟报警", "打哈欠报警"],
      xData: ["10-01", "10-02", "10-03", "10-04", "10-05", "10-06", "10-07"],
      yData: [
        {
          name: "抽烟报警",
          type: "line",
          stack: "Total",
          data: [120, 132, 101, 134, 90, 230, 210],
        },
        {
          name: "打哈欠报警",
          type: "line",
          stack: "Total",
          data: [220, 182, 191, 234, 290, 330, 310],
        },
      ],
    };
  },
  methods: {
    drawBar(id) {
      this.chart = echarts.init(document.getElementById(id));
      this.option = {
        /* title: {
          text: "Stacked Line",
        }, */
        tooltip: {
          trigger: "axis",
        },
        legend: {
          right: 0, //图例组件离右边的距离
          // orient: "vertical", //布局  纵向布局
          orient: "horizontal", //布局  纵向布局
          width: 550, //图行例组件的宽度,默认自适应
          x: "top", //图例显示在右边
          itemWidth: 10, //图例标记的图形宽度
          itemHeight: 10, //图例标记的图形高度
          textStyle: {
            //图例文字的样式
            color: "#000",
            fontSize: 12,
          },
          data: this.tuli,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        /* toolbox: {
          feature: {
            saveAsImage: {},
          },
        }, */
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        yAxis: {
          type: "value",
        },
        series: this.yData,
      };

      this.chart.setOption(this.option);

      this.chart.resize();
    },
  },
  mounted() {
    //
  },
  watch: {
    countTrendData(v) {
      console.log(v);
      this.xData = v.dateList;
      var m = v.trendList;
      this.yAxis = [];
      this.tuli=[];
      this.yData=[];
      for (const i in m) {
        this.tuli[i] = m[i].evetDesc;
        var obj = {
          name: m[i].evetDesc,
          type: "line",
          stack: "Total",
          data: m[i].numList,
        };
        this.yData.push(obj);
      }
      setTimeout(() => {
        console.log(this.tuli);
        this.drawBar("alarmLine");
      }, 100);
    },
  },
};
</script>
<style lang="">
#alarmLine {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/alarm/line.vue